import { inject, observer } from 'mobx-react';


const POSContainer = inject("store", "display")(
    observer(({ children }) => {
        return children
    }))

export default POSContainer;